<!-- выбор языка -->
<template>
	<div v-if="lang === 'ru' || lang === 'en'" class="lang-block" :class="{ 'fixed': fixed }">
        <template v-if="lang === 'ru'">
            <span>RU</span> &nbsp;&nbsp;|&nbsp;&nbsp; <a href="#" @click="(e) => onLangClickDebounce('en', e)">EN</a>
        </template>
        <template v-if="lang === 'en'">
            <a href="#" @click="(e) => onLangClickDebounce('ru', e)">RU</a> &nbsp;&nbsp;|&nbsp;&nbsp; <span>EN</span>
        </template>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
import debounce from 'debounce'
///////////////////////////////////////////////////////////////////////////////
export default {
	name: 'LanguageComponent',

	props: {
		fixed: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	created() {
		this.onLangClickDebounce = debounce(this.onLangClick, 500, true)
	},

	computed: {
		lang() {
			return this.$store.state.lang
		}
	},

	methods: {
		onLangClick(lang, event) {
			event.preventDefault()
			EventBus.$emit('w5-on-lang', lang)
		}
	}

}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.lang-block {
	display: inline-flex;
	font-size: 12px;
	letter-spacing: 1px;
	font-weight: 400;
	margin: 2px 10px 0 40px;
	height: 48px;
	align-items: center;
	color: #787878;
	line-height: 1;
}

.lang-block span {
	font-weight: 500;
}

.lang-block.fixed {
	position: fixed;
	top: 0;
	right: 20px;
}

@media (max-width: 767px) {
	.lang-block {
		font-size: 16px;
		margin: 2px 10px 0 20px;
	}
}
</style>



// WEBPACK FOOTER //
// lang.vue?33d4d352